export default function Triadenschwüre(){
    return(
        <div style={triadenschwuere.container}>
            <h2 style={triadenschwuere.ueberschrift}>Die 36 Triadenschwüre</h2>
            <table style={triadenschwuere.table}>
                <tr>
                    <th style={triadenschwuere.th}>Nummer</th>
                    <th style={triadenschwuere.th}>Schwur</th>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>1.</td>
                    <td style={triadenschwuere.td}>Nachdem ich die Hong Gates betreten habe, muss ich die Eltern und
                    Verwandten meiner geschworenen Brüder wie meine eigenen Verwandten behandeln.
                    Ich werde den Tod durch fünf Donnerschläge erleiden, wenn ich diesen Schwur nicht halte.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>2.</td>
                    <td style={triadenschwuere.td}>Ich werde meinen geschworenen Brüdern helfen, ihre Eltern und Brüder zu bestatten
                    indem ich finanzielle oder physische Hilfe anbiete. Ich werde von fünf Blitzen getötet, wenn ich so tue, als wüsste ich nichts von ihren Problemen.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>3.</td>
                    <td style={triadenschwuere.td}>Wenn Hong-Brüder mein Haus besuchen, werde ich sie mit
                    Unterkunft und Verpflegung versorgen. Ich werde von einer Myriade von Schwertern getötet werden, wenn ich sie als Fremde behandle.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>4.</td>
                    <td style={triadenschwuere.td}>Ich werde meine Hong-Brüder immer anerkennen, wenn sie sich
                    sich zu erkennen geben. Wenn ich sie ignoriere, werde ich von Myriaden von Schwertern getötet werden.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>5.</td>
                    <td style={triadenschwuere.td}>Ich werde die Geheimnisse der Familie Hong nicht preisgeben, nicht einmal gegenüber meinen Eltern, Brüdern oder meiner Frau.
                    Ich werde die Geheimnisse niemals für Geld preisgeben. Wenn ich das tue, werde ich von einer Unzahl von Schwertern getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>6.</td>
                    <td style={triadenschwuere.td}>Ich werde niemals meine geschworenen Brüder verraten.
                    Wenn ich durch ein Missverständnis die Verhaftung eines meiner Brüder verursacht habe, muss ich ihn sofort freilassen.
                    Wenn ich diesen Schwur breche, werde ich von fünf Donnerkeilen getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>7.</td>
                    <td style={triadenschwuere.td}>Ich werde meinen geschworenen Brüdern, die sich in Schwierigkeiten befinden, Hilfe anbieten,
                    damit sie ihre Passagegebühr bezahlen können. Wenn ich diesen Schwur breche, möge ich von fünf Blitzen getötet werden.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>8.</td>
                    <td style={triadenschwuere.td}>Ich darf meinen geschworenen Brüdern oder dem Weihrauchmeister keinen Schaden oder Ärger zufügen.
                    Weihrauchmeister. Wenn ich das tue, werde ich von einer Myriade von Schwerter getötet werden.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>9.</td>
                    <td style={triadenschwuere.td}>Ich darf niemals einen unanständigen Angriff auf die Frauen, Schwestern oder
                    Töchter meiner geschworenen Brüder begehen. Wenn ich diesen Schwur breche, werde ich durch fünf Donnerschläge getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>10.</td>
                    <td style={triadenschwuere.td}>Ich werde niemals Geld oder Eigentum meiner Schwurbrüder veruntreuen.
                    Wenn ich diesen Eid breche, werde ich durch eine Myriade von Schwertern getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>11.</td>
                    <td style={triadenschwuere.td}>Ich werde mich gut um die Frauen und Kinder meiner Eidbrüder kümmern
                    die mir anvertraut wurden. Wenn ich dies nicht tue, werde ich von fünf Donnerkeilen getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>12.</td>
                    <td style={triadenschwuere.td}>Wenn ich falsche Angaben über mich gemacht habe, um der Familie Hong beizutreten,
                    werde ich mit fünf Donnerschlägen getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>13.</td>
                    <td style={triadenschwuere.td}>Sollte ich meine Meinung ändern und meine Mitgliedschaft in der Familie Hong verleugnen,
                    werde ich durch eine Unzahl von Schwertern getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>14.</td>
                    <td style={triadenschwuere.td}>Wenn ich einen geschworenen Bruder beraube oder einem Außenstehenden dabei helfe, werde ich von fünf Donnerkeilen getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>15.</td>
                    <td style={triadenschwuere.td}>Sollte ich einen geschworenen Bruder übervorteilen oder ihm unlautere Geschäfte aufzwinge,
                    werde ich von einer Myriade von Schwertern getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>16.</td>
                    <td style={triadenschwuere.td}>Wenn ich wissentlich das Geld oder den Besitz meines geschworenen Bruders für meinen ausgebe,
                    werde ich durch fünf Donnerschläge getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>17.</td>
                    <td style={triadenschwuere.td}>Wenn ich bei einem Raubüberfall das Geld oder den Besitz eines Eidbruders zu Unrecht an mich genommen habe,
                    muss ich sie ihm zurückgeben. Wenn ich das nicht tue, werde ich durch fünf Donnerkeilen getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>18.</td>
                    <td style={triadenschwuere.td}>Wenn ich verhaftet werde, nachdem ich eine Straftat begangen habe, muss ich meine
                    Strafe hinnehmen und nicht versuchen, die Schuld auf meine Eidbrüder zu schieben. Wenn ich das tue, werde ich von fünf Donnerkeilen getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>19.</td>
                    <td style={triadenschwuere.td}>Wenn einer meiner Eidbrüder getötet oder verhaftet wird oder an einen anderen Ort abgereist ist,
                    so werde ich ihren Frauen und Kindern beistehen, die vielleicht in Not sind. Wenn ich so tue, als wüsste ich nichts von ihren Schwierigkeiten,
                    so werde ich durch fünf Donnerschläge getötet werden.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>20.</td>
                    <td style={triadenschwuere.td}>Wenn einer meiner geschworenen Brüder von anderen angegriffen oder beschuldigt wird, muss ich vortreten und ihm helfen,
                    wenn er im Recht ist, oder ihm raten, es zu unterlassen, wenn er im Unrecht ist. Wenn er wiederholt beleidigt wurde,
                    muss ich unsere anderen Brüder informieren, damit sie ihm körperlich und finanziell helfen. Wenn ich diesen Schwur nicht einhalte,
                    werde ich von fünf Blitzen getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>21.</td>
                    <td style={triadenschwuere.td}>Wenn ich erfahre, dass die Regierung nach einem meiner Brüder, der aus anderen Provinzen oder aus Übersee gekommen ist,
                    werde ich ihn sofort informieren, damit er fliehen kann. Sollte ich diesen Eid brechen, werde ich mit fünf Donnerschlägen getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>22.</td>
                    <td style={triadenschwuere.td}>Ich darf mich nicht mit Außenstehenden zusammentun, um meine geschworenen Brüder beim Glücksspiel zu betrügen.
                    Wenn ich das tue, werde ich von einer Unzahl von Schwertern getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>23.</td>
                    <td style={triadenschwuere.td}>Ich darf keine Zwietracht unter meinen geschworenen Brüdern stiften, indem ich
                    falsche Berichte über einen von ihnen verbreite. Wenn ich das tue, werde ich von einer
                    Myriaden von Schwertern getötet werden.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>24.</td>
                    <td style={triadenschwuere.td}>Ich werde mich nicht eigenmächtig zum Weihrauchmeister ernennen. Ich werde von fünf Donnerkeilen getötet,
                    wenn ich selbst unerlaubte Beförderungen vornehme.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>25.</td>
                    <td style={triadenschwuere.td}>Wenn meine natürlichen Brüder in einen Streit oder Rechtsstreit mit meinen
                    mit meinen geschworenen Brüdern verwickelt sind, darf ich keiner Partei gegen die andere helfen, sondern muss versuchen, die Angelegenheit gütlich zu regeln.
                    Wenn ich diesen Schwur breche, werde ich durch fünf Donnerschläge getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>26.</td>
                    <td style={triadenschwuere.td}>Nachdem ich die Tore von Hong betreten habe, muss ich jeden früheren
                    den ich gegen meine geschworenen Brüder gehegt haben mag, vergessen. Wenn ich das nicht tue, werde ich von fünf Donnerkeilen getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>27.</td>
                    <td style={triadenschwuere.td}>Ich darf kein Gebiet betreten, das von meinen geschworenen Brüdern besetzt ist. Wenn ich so tue,
                    als wüsste ich nichts von den Rechten meiner Brüder in diesem Gebiet, werde ich mit fünf Donnerschlägen getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>28.</td>
                    <td style={triadenschwuere.td}>Ich darf keinen Anteil an den Gütern oder dem Geld meiner Brüder begehren oder suchen.
                    Wenn ich solche Gedanken hege, werde ich mit fünf Donnerkeilen getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>29.</td>
                    <td style={triadenschwuere.td}>Ich darf keine Adresse preisgeben, wo meine Brüder ihr Vermögen aufbewahren.
                    Wenn ich das tue, werde ich von einer Unzahl von Schwertern getötet werden.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>30.</td>
                    <td style={triadenschwuere.td}>Ich darf keine Außenstehenden unterstützen, wenn dies gegen die Interessen eines meiner geschworenen Brüder gerichtet ist.
                    Wenn ich diesen Schwur nicht halte, werde ich durch eine Unzahl von Schwertern getötet werden.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>31.</td>
                    <td style={triadenschwuere.td}>Ich darf die Hong-Bruderschaft nicht ausnutzen, um
                    andere zu unterdrücken oder gewaltsam oder unangemessen zu übervorteilen. Ich
                    muss zufrieden und ehrlich sein. Wenn ich diesen Schwur breche, werde ich von
                    fünf Blitzen getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>32.</td>
                    <td style={triadenschwuere.td}>Ich werde von fünf Donnerkeilen getötet, wenn ich mich unanständig gegenüber
                    den kleinen Kindern der Familien meiner geschworenen Brüder verhalte.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>33.</td>
                    <td style={triadenschwuere.td}>Wenn einer meiner Schwurbrüder ein großes Vergehen begangen hat, darf ich
                    ihn nicht bei der Regierung verraten, um eine Belohnung zu erhalten. Wenn ich diesen Eid breche, werde ich von fünf Blitzen getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>34.</td>
                    <td style={triadenschwuere.td}>Ich darf die Frauen und Konkubinen meiner geschworenen Brüder nicht zu mir nehmen
                    und mit ihnen keinen Ehebruch begehen. Wenn ich das tue, werde ich durch eine Unzahl von Schwertern getötet.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>35.</td>
                    <td style={triadenschwuere.td}>Ich darf niemals Hong-Geheimnisse oder Zeichen verraten, wenn ich mit Außenstehenden spreche.
                    Wenn ich das tue, werde ich von einer Myriade von Schwertern getötet werden.</td>
                </tr>
                <tr>
                    <td style={triadenschwuere.td}>36.</td>
                    <td style={triadenschwuere.td}>Nachdem ich die Tore von Hong betreten habe, werde ich loyal und treu sein und
                    und werde mich bemühen, die Qing zu stürzen und die Ming wiederherzustellen, indem ich meine Bemühungen mit denen meiner geschworenen Brüder koordiniere, auch wenn
                    meine Brüder und ich nicht den gleichen Beruf haben. Unser
                    gemeinsames Ziel ist es, unsere fünf Vorfahren zu rächen.</td>
                </tr>
            </table>
            <p style={triadenschwuere.paraUeberschrift}>Bedeutung der 5 Donnerkeilen:</p>
            <p style={triadenschwuere.para}>Die 5 Donnerkeile sind eine Hypothese des Taoismus.
            Der Taoismus untersucht die Harmonie von Mensch und Natur. Sie glaubten, dass es 5 Elemente gibt, aus denen sich alles auf der Erde zusammensetzt.
            Die Donnerkeile könnten auch mit diesen 5 Elementen in Verbindung gebracht werden.</p>
            <ul style={triadenschwuere.ul}>
                <li>Gold bezieht sich auf alle Arten von Metall, was bedeutet, dass Waffen aus Metall verletzen oder töten können.</li>
                <li>Holz bezieht sich auf alle Pflanzungen, was bedeutet, dass sie mit Keulen angegriffen werden oder Verletzungen durch umgestürzte Bäume erleiden.</li>
                <li>Wasser bezieht sich auf Flüsse, Seen und das Meer, was Ertrinken bedeutet.</li>
                <li>Feuer bedeutet Hitze, Blitz und Donner, Verbrennung.</li>
                <li>Erde bedeutet Verschüttung, Erdrutsch, umgestürzte Häuser usw.</li>
            </ul>
            <p style={triadenschwuere.para}>Durch die Verwendung als Treueschwur, der impliziert, dass Verrat den sicheren Tod bedeutet.</p>
        </div>
    )
}

const triadenschwuere = {
    container: {
        margin: 0,
        paddingTop: 50,
        backgroundColor: "#444",
        paddingLeft: "10%",
        paddingRight: "10%"
    },

    ueberschrift: {
        margin: 0,
        color: "white",
        border: "1px solid white",
        borderRadius: "5px",
        padding: 10
    },

    table: {
        borderCollapse: "collapse",
        width: "100%",
        marginTop: 30
    },

    td: {
        border: "1px solid #ddd",
        textAlign: "left",
        padding: "8px",
        color: "white"
    },

    th: {
        border: "1px solid #ddd",
        textAlign: "left",
        padding: "8px",
        color: "white"
    },

    paraUeberschrift: {
        color: "white",
        padding: 10,
        marginTop: 30,
        marginBottom: 0,
        border: "1px solid white",
        borderRadius: "5px"
    },

    para: {
        color: "white",
        paddingTop: 30,
        paddingBottom: 30,
        marginBottom: 0
    },

    ul: {
        color: "white"
    }
}